<div class="m-4 px-6 pb-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    @if (workFlowView) {
      <div class="sm:px-8 px-0 bg-white flex flex-col gap-4">
        <div class="grid gap-3 grid-cols-3">
          <app-input-general-select
            [formControlGeneral]="gpsForm.controls.workFlowTypeId"
            [arrayData]="workFlowList"
            [inputSelect]="{ value: '', description: 'description' }"
            class="col-span-full xl:col-span-2"
            [label]="'general-pages.gps.workflow'"
            [placeholder]="'general-pages.gps.workflow'"
          ></app-input-general-select>
        </div>

        <div
          class="px-4 py-2 text-general-subtitle text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
        >
          {{
            this.gpsForm.get('workFlowTypeId')!.value
              ? this.gpsForm.get('workFlowTypeId')!.value!.description
              : 'GPS'
          }}
        </div>

        <div class="grid gap-3 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
          <div class="col-span-full text-general-subtitle text-[#1f87bf]">
            {{ 'general-pages.gps.location.title' | translate }}
            {{
              this.gpsForm.get('workFlowTypeId')!.value
                ? this.gpsForm.get('workFlowTypeId')!.value!.description
                : ''
            }}
          </div>

          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.zipCode"
            [label]="'general-pages.gps.location.zipCode' | translate"
            [placeholder]="'general-pages.gps.location.zipCode' | translate"
            [mask]="'00000'"
            [allowNegativeNumbers]="false"
            [thousandSeparator]="''"
            [prefix]="''"
          ></app-input-general>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.state"
            [label]="'general-pages.gps.location.state' | translate"
            [placeholder]="'general-pages.gps.location.state' | translate"
          ></app-input-general>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.municipality"
            [label]="'general-pages.gps.location.municipality' | translate"
            [placeholder]="'general-pages.gps.location.municipality' | translate"
          ></app-input-general>

          <app-input-general-select
            [formControlGeneral]="gpsForm.controls.location.controls.localities"
            class="col-span-full xl:col-span-2"
            [label]="'general-pages.gps.location.settlement' | translate"
            [placeholder]="'general-pages.gps.location.settlement' | translate"
            [inputSelect]="{ value: 'id', description: 'value' }"
            [arrayData]="localities"
          ></app-input-general-select>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.city"
            [label]="'general-pages.gps.location.city' | translate"
            [placeholder]="'general-pages.gps.location.city' | translate"
          ></app-input-general>

          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.street"
            class="col-span-full"
            [label]="'general-pages.gps.location.street' | translate"
            [placeholder]="'general-pages.gps.location.street' | translate"
          ></app-input-general>

          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.exteriorNumber"
            [label]="'general-pages.gps.location.exteriorNumber' | translate"
            [placeholder]="'general-pages.gps.location.exteriorNumber' | translate"
          ></app-input-general>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.interiorNumber"
            [label]="'general-pages.gps.location.interiorNumber' | translate"
            [placeholder]="'general-pages.gps.location.interiorNumber' | translate"
          ></app-input-general>
          <div class="hidden gl:block"></div>

          <app-input-general
            [formControlGeneral]="gpsForm.controls.location.controls.phone"
            [label]="'general-pages.gps.location.phone' | translate"
            [placeholder]="'general-pages.gps.location.phone' | translate"
            [mask]="'(000) 000-0000'"
          ></app-input-general>
        </div>

        <div class="grid gap-3 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
          <div class="col-span-full text-general-subtitle text-[#1f87bf]">
            {{ 'general-pages.gps.contact.title' | translate }}
            {{
              this.gpsForm.get('workFlowTypeId')!.value
                ? this.gpsForm.get('workFlowTypeId')!.value!.description
                : ''
            }}
          </div>

          <!--  revisar valor -1 pedir a jorge servicio con catalogo de promotores -->
          <!-- no se usa preguntar a jorge si se oculta siempre es 0 preguntar si se desea uisar -->
          <app-input-general-select
            [formControlGeneral]="gpsForm.controls.contact.controls.contact"
            class="col-span-full"
            [label]="'general-pages.gps.contact.contact' | translate"
            [placeholder]="'general-pages.gps.contact.contact' | translate"
            [inputSelect]="{ value: 'value', description: 'description' }"
            [arrayData]="[
              { value: 0, description: 'Nuevo contacto' },
              { value: -1, description: 'Promotor como contacto' },
            ]"
          ></app-input-general-select>

          <div class="hidden gl:block"></div>

          <app-input-general
            [formControlGeneral]="gpsForm.controls.contact.controls.lastName"
            [label]="'general-pages.gps.contact.lastName' | translate"
            [placeholder]="'general-pages.gps.contact.lastName' | translate"
            [pattern]="'[a-zA-Z]*'"
          ></app-input-general>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.contact.controls.motherLastName"
            [label]="'general-pages.gps.contact.motherLastName' | translate"
            [placeholder]="'general-pages.gps.contact.motherLastName' | translate"
            [pattern]="'[a-zA-Z]*'"
          ></app-input-general>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.contact.controls.firstName"
            [label]="'general-pages.gps.contact.firstName' | translate"
            [placeholder]="'general-pages.gps.contact.firstName' | translate"
            [pattern]="'[a-zA-Z]*'"
          ></app-input-general>

          <app-input-general
            [formControlGeneral]="gpsForm.controls.contact.controls.contactPhone"
            [label]="'general-pages.gps.contact.contactPhone' | translate"
            [placeholder]="'general-pages.gps.contact.contactPhone' | translate"
            [mask]="'(000) 000-0000'"
          ></app-input-general>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.contact.controls.mobilePhone"
            [label]="'general-pages.gps.contact.mobilePhone' | translate"
            [placeholder]="'general-pages.gps.contact.mobilePhone' | translate"
            [mask]="'(000) 000-0000'"
          ></app-input-general>
          <app-input-general
            [formControlGeneral]="gpsForm.controls.contact.controls.email"
            [label]="'general-pages.gps.contact.email' | translate"
            [placeholder]="'general-pages.gps.contact.email' | translate"
          ></app-input-general>

          <app-input-general-text
            [formControlGeneral]="gpsForm.controls.contact.controls.comments"
            class="col-span-full"
            [label]="'general-pages.gps.contact.comments' | translate"
            [placeholder]="'general-pages.gps.contact.comments' | translate"
          ></app-input-general-text>
        </div>

        @if (fieldEditClosing && fieldEditClosing.length) {
          <app-hybrid-form
            [quotationId]="quotationId"
            [workFlowLocation]="workFlowLocation"
            [hybridForm]="editClosingHybridForm"
            [fieldItem]="fieldEditClosing"
            [title]="
              this.gpsForm.get('workFlowTypeId')!.value
                ? this.gpsForm.get('workFlowTypeId')!.value!.description
                : ''
            "
          ></app-hybrid-form>
        }
        @if (fieldLocation && fieldLocation.length) {
          <app-hybrid-form
            [workFlowLocation]="workFlowLocation"
            [quotationId]="quotationId"
            [hybridForm]="locationHybridForm"
            [fieldItem]="fieldLocation"
          ></app-hybrid-form>
        }

        <div class="grid gap-3 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
          <app-input-general-select
            [formControlGeneral]="gpsForm.controls.quantity"
            [arrayData]="[
              { value: 1, description: '1' },
              { value: 2, description: '2' },
            ]"
            [inputSelect]="{ value: 'value', description: 'description' }"
            class="col-span-full xl:col-span-1"
            [label]="'Quantity'"
            [placeholder]="'Quantity'"
          ></app-input-general-select>
          @if (requestButton) {
            <button
              class="bg-primary! rounded-md text-white! text-center px-4 w-auto! h-[45px]"
              mat-menu-item
              (click)="createWorkflowProject()"
              [disabled]="!valitdForms()"
            >
              {{ 'general-pages.gps.closing.requestButton' | translate }}
            </button>
          }
        </div>
      </div>
    } @else {
      <div
        class="sm:px-8 px-0 bg-white flex flex-col justify-center text-general items-center gap-4"
      >
        {{ errosMess }}
      </div>
    }
  </div>
</div>
